export const partnerStateType = {
  IDLE: 'IDLE',
  CLOSED: 'CLOSED',
  DEACTIVATED: 'DEACTIVATED',
  OPEN: 'OPEN',
  INACTIVE: 'INACTIVE',
}
